export const CHART_CONFIG = {
  dimensions: {
    margin: { top: 20, right: 0, bottom: 30, left: 0 },
    height: 300
  },
  grid: {
    leftPadding: 80
  },
  tooltip: {
    minSpaceToEdge: 100
  },
  style: {
    lineWidth: 2,
    opacity: 0.2,
    fontSize: {
      xAxis: "12px",
      yAxis: "12px"
    },
    fontWeight: "500"
  }
} as const;
